import React, { useRef, useEffect, useState } from 'react'

import $ from 'jquery'
import Slider from 'react-slick'
import Polaris from 'src/lib/Polaris'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import Card from 'src/components/card/fixed'

import * as styles from './latests.module.scss'


const NextArrow = ({ className, onClick, currentSlide, slideCount }) => (
    <button className={className + ' ' + styles.next} onClick={onClick} data-disabled={currentSlide === slideCount - 1}>next</button>
)

const PrevArrow = ({ className, onClick, currentSlide }) => (
    <button className={className + ' ' + styles.prev} onClick={onClick} data-disabled={currentSlide === 0}>previous</button>
)

const Latests = ({ latests }) => {

    const slider = useRef(null)
    const wrapper = useRef(null)
    const [perRow, setPreRow] = useState(3)
    const [current, setCurrent] = useState(0)

    const config = {
        slidesToShow: 1,
        slidesPerRow: perRow,
        dots: false,
        infinite: false,
        speed: 750,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (oldIndex, newIndex) => {
            setCurrent(newIndex)
        }
    }

    useEffect(() => {
        const computedStyle = window.getComputedStyle(wrapper.current, '::before')

        let cols = null

        const resizeID = Polaris.util.onResize(() => {
            if (computedStyle.getPropertyValue('font-family').match(/"(\d)"/)) {
                const _cols = parseInt(RegExp.$1)

                if (cols !== _cols) {
                    cols = _cols
                    setPreRow(_cols)
                }
            }
        })
        return () => Polaris.util.offResize(resizeID)
    }, [setPreRow])

    
    useEffect(() => {
        $(wrapper.current).find('.slick-slide').each((i, el) => {
            el.style.opacity = current === i ? 1 : 0
        })
    }, [perRow, current])
    


    if (latests.nodes.length > 0) {
        return (
            <SlideinWrap className={styles.latests}>
                <SlideinItem className={styles.title}>最新の記事</SlideinItem>
                <div className={styles.slide} ref={wrapper}>
                    {perRow > 0 ? (
                        <div className={styles.slideContent}>
                            <Slider {...config} ref={slider}>
                                {latests.nodes.map((node, i) => (
                                    <div key={i} className={styles.slideItem}>
                                        <Card data={node} size={3} />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    ) : (
                        <ul>
                            {latests.nodes.slice(0, 3).map((node, i) => (
                                <li key={i} className={styles.slideItem}>
                                    <Card data={node} size={3} />
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </SlideinWrap>
        )
    } else {
        return null
    }
}

export default Latests